export const TranslateGender = (gender: string) => {
  const dictionary: {[x: string]: string} = {Male: 'Homem', man: 'Homem', woman: 'Mulher', Female: 'Mulher', undetermined: 'Indeterminado'}
  return dictionary[gender] ?? 'Desconhecido'
}
